import { useMemo } from "react";
import { useDesignPropertyShortcuts } from "@/components/Canvas/hooks/useDesignPropertyShortcuts";
import { useKeyboardShortcuts } from "../core/useKeyboardShortcuts";
import { ShortcutMap } from "../core/types";

export const useAutoLayoutShortcuts = () => {
  const { applyAutoLayoutToggle, applyRemoveAutoLayout } =
    useDesignPropertyShortcuts();

  const shortcuts: ShortcutMap = useMemo(
    () => ({
      "shift+a": {
        handler: applyAutoLayoutToggle,
        description: "Add auto layout",
      },
      "alt+shift+a": {
        handler: applyRemoveAutoLayout,
        description: "Remove auto layout",
      },
    }),
    [applyAutoLayoutToggle, applyRemoveAutoLayout],
  );

  useKeyboardShortcuts({ shortcuts });
};
